<template>
    <div class="bg-white">
        <HeadView logo :province="province" :active="-1" @closeProvince="closeProvince"></HeadView>
        <BannerView :province="province" :suspension="false"></BannerView>
        <div class="px-30 py-30 bg-white">
            <div class="title">{{ article.title }}</div>
            <div class="fr-ac-jc mb-10">
                <p class="px-20"><span>文章来源：</span>{{ article.source }}</p>
                <p class="px-20"><span>发布时间：</span>{{ article.publishtime }}</p>
            </div>
            <div v-html="article.content" class="content"></div>
        </div>
    </div>
</template>
<script>
import { getArchives, getBusinessProvince, homepage_homePageAd } from '@/utils/api';
import { getCookie } from '@/utils/common';

export default {
    data(){
        return {
            province: getCookie('province')
        }
    },
    computed: {
        article() {
            return this.$store.state.article || {};
        },
    },
    // SSR 阶段调用:拿文章数据 commit 到 store,HTML 直出内容,SEO 能抓到
    async asyncData({ store, route }) {
        
        const id = (route && route.query && route.query.id) || '';
        // 并发拉取:文章详情 + 广告数据(banner 用)
        // 注意:广告只在 store.list_ad 为空时才拉,避免每次跳转文章都重复请求
        const tasks = [];
        if (id) {
            tasks.push(
                getArchives({ archives_id: id }).then(res => {
                    if (res && res.status == 200 && res.data && res.data.content) {
                        store.commit('SET_ARTICLE', res.data.content);
                    }
                }).catch(err => {
                    console.log('[fill_article asyncData] 文章出错:', err && err.message);
                })
            );
        }
        const ad = store.state.page_one.list_ad;
        if (!ad || !ad.banner) {
            tasks.push(
                homepage_homePageAd({ sf: getCookie('province') }).then(res => {
                    if (res && res.status == 200 && res.data) {
                        store.commit('SET_PAGE_LIST', { data: res.data, type: 'ad' });
                    }
                }).catch(err => {
                    console.log('[fill_article asyncData] 广告出错:', err && err.message);
                })
            );
        }
        const province = store.state.page_one.list_province;
        if (!province || !province.length) {
            tasks.push(
                getBusinessProvince({ }).then(res => {
                    if (res && res.status == 200) {
                        store.commit('SET_PAGE_LIST', { data: res.data, type: 'province' });
                    }
                }).catch(err => {
                    console.log('[fill_article asyncData] 省份出错:', err && err.message);
                })
            );
        }
        if (tasks.length) await Promise.all(tasks);
    },
    mounted() {
        this.syncMeta();
    },
    watch: {
        article() {
            // SPA 路由跳转后 asyncData 完成,article 变化时同步 meta
            this.syncMeta();
        },
    },
    methods: {
        async closeProvince(val1, val2) {
            this.province = val1;
            try {
                const res = await homepage_homePageAd({ sf: getCookie('province') });
                if (res && res.status == 200 && res.data) {
                    this.$store.commit('SET_PAGE_LIST', { data: res.data, type: 'ad' });
                }
            } catch (err) {
                console.log('[closeProvince] 广告出错:', err && err.message);
            }
        },
        // 动态更新/创建 <meta name="xxx" content="yyy">
        updateMeta(name, content) {
            if (!name || content == null) return;
            document.head.querySelectorAll(`meta[name="${name}"]`).forEach(el => el.remove());
            let el = document.createElement('meta');
            el.setAttribute('name', name);
            el.setAttribute('content', content);
            document.head.appendChild(el);
        },
        // 用文章真实数据同步 title 和 meta(客户端导航时覆盖路由静态 meta)
        syncMeta() {
            const a = this.article;
            if (!a || !a.title) return;
            document.title = a.title;
            this.updateMeta('description', a.description || a.title);
            this.updateMeta('keywords', a.keywords || '文章详情,高考资讯');
        },
        // 客户端:用户点按钮重新拉取(可选,也可不用)
        async getDetail() {
            const id = this.$route.query.id || '';
            if (!id) return;
            try {
                const res = await getArchives({ archives_id: id });
                if (res && res.status == 200 && res.data && res.data.content) {
                    this.$store.commit('SET_ARTICLE', res.data.content);
                }
            } catch (err) {
                if (this.$message) {
                    this.$message({
                        message: (err && err.msg) || '请求失败',
                        type: "warning",
                    });
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>

.title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
}
.content {
    width: 1000px;
    margin: 0 auto;
    ::v-deep {
        p, span, img {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        img {
            height: auto;
            display: block;
        }
    }
}
</style>